import { Component, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FOOTER_LINKS, PATHS } from '../../../../../shared/paths';
import { LANGUAGE } from '../../../../../shared/injection-tokens';
import { LABELS } from '../../../../../shared/labels';
import { Language } from '../../../../../shared/salesforce-types';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    paths: (typeof PATHS)[Language.En];

    footerLinks = FOOTER_LINKS;

    labels: (typeof LABELS)[Language.En];

    constructor(@Inject(LANGUAGE) language: BehaviorSubject<Language>) {
        this.paths = PATHS[language.value];
        this.labels = LABELS[language.value];
    }
}
